import request from '@/utils/request'

/**
 * 获取页面详情（按code）
 */
export function getPageDetail(data) {
  return request.get('/page/detail', data)
}

/**
 * 获取页面详情（按id）
 */
export function getPageDetailById(data) {
  return request.get('/page/detail-by-id', data)
}

/**
 * 获取页面列表
 */
export function getPageList(data) {
  return request.get('/page/list', data)
}

/**
 * 按类型获取页面列表
 */
export function getPageListByType(data) {
  return request.get('/page/list-by-type', data)
}

/**
 * 获取首页数据（兼容旧接口）
 */
export function getHomeData(data) {
  return request.get('/page/home', data)
}

/**
 * 获取首页头部数据（banner、快捷入口、导航）
 */
export function getHomeHeader(data) {
  return request.get('/page/home/header', data)
}

/**
 * 获取首页资讯卡片数据
 */
export function getHomeInfoCards(data) {
  return request.get('/page/home/info-cards', data)
}

/**
 * 获取首页科室导航数据
 */
export function getHomeDepartments(data) {
  return request.get('/page/home/departments', data)
}

/**
 * 获取首页医生团队数据
 */
export function getHomeDoctors(data) {
  return request.get('/page/home/doctors', data)
}

/**
 * 获取首页底部数据（地图、证书、公益）
 */
export function getHomeFooter(data) {
  return request.get('/page/home/footer', data)
}
